import { SentryErrorComponent } from '@components/Fallback'
import {
  CheckPermissionsWrapper,
  Operations,
  Permission,
  RESOURCE_ID,
} from '@lib/permissions'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const mediaLibraryReadPermission = new Permission(
  RESOURCE_ID.mediaItem,
  Operations.Read
)

const MediaLibraryBaseRoute = () => (
  <CheckPermissionsWrapper permissions={[mediaLibraryReadPermission]}>
    <Outlet />
  </CheckPermissionsWrapper>
)

export const Route = createFileRoute('/_auth/o/$orgId/mediaLibrary')({
  component: MediaLibraryBaseRoute,
  loader: async () => ({
    crumb: 'Media Library',
  }),
  errorComponent: SentryErrorComponent,
})
